import { render, staticRenderFns } from "./ModalEditSearchWidget.vue?vue&type=template&id=64c8b398"
import script from "./ModalEditSearchWidget.vue?vue&type=script&lang=js"
export * from "./ModalEditSearchWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports